function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgHolderIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.247,
    height: 28.246,
    viewBox: "0 0 28.247 28.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "img-holder-icn",
    d: "M2.629 28.247a2.525 2.525 0 0 1-1.847-.782A2.525 2.525 0 0 1 0 25.619V2.638A2.541 2.541 0 0 1 .782.785 2.522 2.522 0 0 1 2.629 0h22.98a2.532 2.532 0 0 1 1.852.784 2.535 2.535 0 0 1 .785 1.853v22.98a2.675 2.675 0 0 1-2.637 2.628H2.629m0-2.628h22.98V2.638H2.629zm0 0zm3.262-3.576h16.494a.6.6 0 0 0 .568-.351.669.669 0 0 0-.04-.7l-4.486-6.02a.675.675 0 0 0-.529-.264.633.633 0 0 0-.526.264l-4.564 5.887-3.052-4.19a.669.669 0 0 0-1.065 0L5.4 20.988a.628.628 0 0 0-.079.7.6.6 0 0 0 .568.351",
    transform: "translate(0 -.001)",
    style: {
      fill: "#e0e0e0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHolderIcn);
export default __webpack_public_path__ + "static/media/img-holder-icn.dd19344f584c46adc1b9637c252a1c17.svg";
export { ForwardRef as ReactComponent };